export default __webpack_public_path__ + "static/media/Card-GoMastercard.91a634df.png";